export default __webpack_public_path__ + "static/media/Iconvirus2.a1ddab9a.svg";